export const GET_NOTIFICATIONS_LISTING = "GET_NOTIFICATIONS_LISTING";
export const SET_NOTIFICATIONS_COUNT = "SET_NOTIFICATIONS_COUNT";
export const SET_ALL_READ = "SET_ALL_READ";
export const SET_NOTIFICATIONS_LOADING = "SET_NOTIFICATIONS_LOADING";
